export default class NewsFactory {
  constructor() {
    const news = document.querySelectorAll('.news.has-load-more');

    news.forEach((newsModule) => new News(newsModule));
  }
}

class News {
  constructor(root) {
    this.root = root;
    this.items = root.querySelectorAll('.news__item');
    this.btnMore = root.querySelector('.news__more.load-more');
    this.itemsCount = Number(root.dataset.itemsCount);
    // this.pageSize = Number(root.dataset.pageSize);

    this.page = 1;
    this.showItems();
    this.hideLoadMore();

    this.btnMore.addEventListener('click', () => {
      this.page++;
      this.showItems();
      this.hideLoadMore();
    });
  }

  showItems() {
    this.items.forEach((item, index) => {
      if (index >= this.itemsCount * this.page) {
        return;
      }

      item.classList.add('visible');
    });
  }

  hideLoadMore() {
    if (this.items.length <= this.itemsCount * this.page) {
      this.root.classList.add('hide-load-more');
    }
  }
}
